import { reportWorkTypes } from "constants/layout";
import { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
    Card,
    CardBody,
    Col,
    Row,
    Button
} from "reactstrap";
import { getBranches, getOptions } from "./optionsServices";
import "flatpickr/dist/themes/material_red.css"
import Flatpickr from "react-flatpickr"
import Timezone from "utils/timezone";
import { MultiSelect } from "react-multi-select-component";

const initObj = {
    type: 'all',
    order_type: 'all',
    branch: 'all',
    dates: [new Date()],
    client: [],
    city: [],
    category: [],
    producttype: [],
    product_type: [],
    p_type: [],
    product: []
};

export const Filters = ({ callback, filterOptions = {} }) => {
    const [branches, setBranches] = useState(null);
    const [clients, setClients] = useState(null);
    const [cities, setCities] = useState(null);
    const [selectedDates, setSelectedDates] = useState([new Date()]);

    const [categories, setCategories] = useState(null);
    const [productTypes, setProductTypes] = useState(null);
    const [products, setProducts] = useState(null);
    const [filterData, setFilterData] = useState(initObj);
    const [dropdownSelection, setDropdownSelection] = useState({
        city: [],
        client: [],
        p_catygory: [],
        p_type: [],
        product: []
    });

    useEffect(() => {
        let mounted = true;

        const loadBranches = async () => {
            const result = await getBranches();
            if (mounted) {
                setBranches(result);
            }
        };

        loadBranches();
        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        let mounted = true;

        const loadOptions = async () => {
            const calls = [];
            const keys = [];

            if (filterOptions.city) {
                calls.push(getOptions(filterData.branch, 'cities'));
                keys.push('cities');
            }

            if (filterOptions.client) {
                calls.push(getOptions(filterData.branch, 'clients'));
                keys.push('clients');
            }

            if (filterOptions.category) {
                calls.push(getOptions(filterData.branch, 'categories'));
                keys.push('categories');
            }

            if (filterOptions.p_type) {
                calls.push(getOptions(filterData.branch, 'productTypes'));
                keys.push('productTypes');
            }

            if (filterOptions.product) {
                calls.push(getOptions(filterData.branch, 'products'));
                keys.push('products');
            }

            const results = await Promise.all(calls);

            if (mounted) {
                results.forEach((res, idx) => {
                    switch (keys[idx]) {
                        case 'cities': setCities(res); break;
                        case 'clients': setClients(res); break;
                        case 'categories': setCategories(res); break;
                        case 'productTypes': setProductTypes(res); break;
                        case 'products': setProducts(res); break;
                    }
                });

                // Trigger parent callback only once after all options load
                handleSubmit();
            }
        };

        loadOptions();

        return () => {
            mounted = false;
        };
    }, [filterData.branch]);

    const handleSubmit = () => {
        const activeFilters = {};

        if (filterOptions?.order_type) {
            activeFilters.type = filterData.type || 'all';
            activeFilters.order_type = filterData.type || 'all';
        }
        if (filterOptions?.city) {
            activeFilters.city = filterData.city || [];
        }
        if (filterOptions?.client) {
            activeFilters.client = filterData.client || [];
        }
        if (filterOptions?.dates) {
            activeFilters.dates = filterData.dates || [];
        }
        if (filterOptions?.category) {
            activeFilters.category = filterData.category || [];
        }
        if (filterOptions?.p_type) {
            const pTypeVal = filterData.product_type || filterData.producttype || [];
            activeFilters.product_type = pTypeVal;
            activeFilters.producttype = pTypeVal;
            activeFilters.p_type = pTypeVal;
        }
        if (filterOptions?.product) {
            activeFilters.product = filterData.product || [];
        }
        if (filterOptions?.branch) {
            activeFilters.branch = filterData.branch || 'all';
        }

        for (const key in filterOptions) {
            if (filterOptions[key] && filterData[key] !== undefined && activeFilters[key] === undefined) {
                activeFilters[key] = filterData[key];
            }
        }

        callback(activeFilters);
    };

    const handleReset = () => {
        setFilterData(initObj);
        setSelectedDates([new Date()]);
        setDropdownSelection({
            city: [],
            client: [],
            p_catygory: [],
            p_type: [],
            product: []
        });

        const resetFilters = {};
        if (filterOptions?.order_type) {
            resetFilters.type = 'all';
            resetFilters.order_type = 'all';
        }
        if (filterOptions?.city) resetFilters.city = [];
        if (filterOptions?.client) resetFilters.client = [];
        if (filterOptions?.dates) resetFilters.dates = [Timezone(new Date())];
        if (filterOptions?.category) resetFilters.category = [];
        if (filterOptions?.p_type) {
            resetFilters.product_type = [];
            resetFilters.producttype = [];
            resetFilters.p_type = [];
        }
        if (filterOptions?.product) resetFilters.product = [];
        if (filterOptions?.branch) resetFilters.branch = 'all';

        callback(resetFilters);
    };

    return (
        <Row>
            <Col>
                <Card className="cardfilters">
                    <CardBody className="p-0 border-0 shadow-none">
                        <Row>
                            {
                                filterOptions?.order_type &&
                                <Col className={'mb-3'}>
                                    <label>Order Type</label>
                                    <select
                                        className="form-control"
                                        value={filterData.type || 'all'}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setFilterData(prev => ({ ...prev, type: val, order_type: val }));
                                        }}
                                    >
                                        {
                                            reportWorkTypes?.map((v, i) => <option key={`WT_${i}`} value={v.id}>{v.title}</option>)
                                        }
                                    </select>
                                </Col>
                            }

                            {
                                filterOptions?.city &&
                                <Col className={'mb-3'}>
                                    <label>Select City</label>
                                    <MultiSelect
                                        options={cities || []}
                                        value={dropdownSelection?.city || []}
                                        onChange={(e) => {
                                            const selected = e || [];
                                            setDropdownSelection(prev => ({ ...prev, city: selected }));
                                            setFilterData(prev => ({ ...prev, city: selected.map(item => item.value) }));
                                        }}
                                        labelledBy="Select"
                                    />
                                </Col>
                            }

                            {
                                filterOptions?.client &&
                                <Col className={'mb-3'}>
                                    <label>Select Client</label>
                                    <MultiSelect
                                        options={clients || []}
                                        value={dropdownSelection?.client || []}
                                        onChange={(e) => {
                                            const selected = e || [];
                                            setDropdownSelection(prev => ({ ...prev, client: selected }));
                                            setFilterData(prev => ({ ...prev, client: selected.map(item => item.value) }));
                                        }}
                                        labelledBy="Select"
                                    />
                                </Col>
                            }

                            {
                                filterOptions?.dates &&
                                <Col className={'mb-4'}>
                                    <label>Date Range</label>
                                    <Flatpickr
                                        className="form-control d-block"
                                        placeholder="DD-MM-YYYY"
                                        options={{
                                            mode: "range",
                                            dateFormat: "d-m-Y"
                                        }}
                                        value={selectedDates}
                                        onChange={
                                            (e) => {
                                                const dates = e.map(dateString => Timezone(dateString));
                                                setFilterData(prev => ({ ...prev, dates: dates }));
                                                setSelectedDates(e);
                                            }
                                        }
                                    />
                                </Col>
                            }

                            {
                                filterOptions?.category &&
                                <Col className={'mb-3'}>
                                    <label>Product Category</label>
                                    <MultiSelect
                                        options={categories || []}
                                        value={dropdownSelection?.p_catygory || []}
                                        onChange={(e) => {
                                            const selected = e || [];
                                            setDropdownSelection(prev => ({ ...prev, p_catygory: selected }));
                                            setFilterData(prev => ({ ...prev, category: selected.map(item => item.value) }));
                                        }}
                                        labelledBy="Select"
                                    />
                                </Col>
                            }

                            {
                                filterOptions?.p_type &&
                                <Col className={'mb-3'}>
                                    <label>Product type</label>
                                    <MultiSelect
                                        options={productTypes || []}
                                        value={dropdownSelection?.p_type || []}
                                        onChange={(e) => {
                                            const selected = e || [];
                                            const values = selected.map(item => item.value);
                                            setDropdownSelection(prev => ({ ...prev, p_type: selected }));
                                            setFilterData(prev => ({
                                                ...prev,
                                                producttype: values,
                                                product_type: values,
                                                p_type: values
                                            }));
                                        }}
                                        labelledBy="Select"
                                    />
                                </Col>
                            }

                            {
                                filterOptions?.product &&
                                <Col className={'mb-3'}>
                                    <label>Product</label>
                                    <MultiSelect
                                        options={products || []}
                                        value={dropdownSelection?.product || []}
                                        onChange={(e) => {
                                            const selected = e || [];
                                            setDropdownSelection(prev => ({ ...prev, product: selected }));
                                            setFilterData(prev => ({ ...prev, product: selected.map(item => item.value) }));
                                        }}
                                        labelledBy="Select"
                                    />
                                </Col>
                            }

                            <Col md={1} style={{ marginTop: '24px', width: '142px' }}>
                                <Button style={{ backgroundColor: "#3d1e08", borderColor: "#3d1e08", color: "#fff" }} className="float-end" onClick={handleSubmit} > Submit </Button>
                                <Button color="light" className="float-end mdi mdi-refresh me-1 border" title="reset filters" onClick={handleReset} ></Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};
